import { UnlockButton } from 'blaze-components/WriterTopBar/UnlockButton'
import { Text } from 'blaze-ui/Text/Text'
import { useHistory, useLocation } from 'react-router-dom'
import { FileType, FileTypeFilter } from 'screens/AllFiles/components/FileTypeFilter/FileTypeFilter'
import { useMemo } from 'react'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { SearchButton } from 'blaze-components/WriterTopBar/SearchButton'

export const AllFilesMobileTopBar = () => {
  const history = useHistory()
  const location = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location])
  const theme = useHeaderTheme()

  return (
    <MobileTopBarContainer.Root data-theme={theme}>
      <MobileTopBarContainer.Left>
        <UnlockButton />
        <SearchButton />
      </MobileTopBarContainer.Left>
      <MobileTopBarContainer.Center>
        <Text lineClamp={1}>Recent</Text>
      </MobileTopBarContainer.Center>
      <MobileTopBarContainer.Right>
        <FileTypeFilter
          fileType={(searchParams.get('fileTypeFilter') || 'all') as FileType}
          onSelect={(type: FileType) => {
            searchParams.set('fileTypeFilter', type)
            history.replace({ search: searchParams.toString() })
          }}
        />
      </MobileTopBarContainer.Right>
    </MobileTopBarContainer.Root>
  )
}
